export default __webpack_public_path__ + "assets/images/a8547361a134570aef8cf373f37dad5a.png";